// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__2SP_S","colMin":"styles_colMin__2Pc1U","colCheckbox":"styles_colCheckbox__1Hjl_"};